import React from 'react'
import { withRouter } from 'react-router-dom'

import { DataTable } from 'primereact/datatable' 
import { Column } from 'primereact/column'
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { Dropdown } from 'primereact/dropdown'
import { Dialog } from 'primereact/dialog'
import { MultiSelect } from 'primereact/multiselect'
import { TreeSelect } from 'primereact/treeselect';
import { InputText } from 'primereact/inputtext'
import { InputMask } from 'primereact/inputmask';
import { InputNumber } from 'primereact/inputnumber'
import { AutoComplete } from 'primereact/autocomplete';
import { Accordion, AccordionTab } from 'primereact/accordion'
import { InputTextarea } from 'primereact/inputtextarea'
import { Calendar } from 'primereact/calendar'
import { locale, addLocale, updateLocaleOption, updateLocaleOptions, localeOption, localeOptions } from 'primereact/api'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import NavBar from '../../componentes/Navbar'
import Progresso from '../../componentes/Progresso'
import ProcessoService from '../../app/service/ProcessoService'
import GrupoTrabalhoService from '../../app/service/GrupoTrabalhoService'
import TipoAcaoService from '../../app/service/TipoAcaoService'
import StatusProcessualService from '../../app/service/StatusProcessualService'
import TipoDecisaoService from '../../app/service/TipoDecisao'
import ObjetoScaoService from '../../app/service/ObjetoAcaoService'
import PessoaService from '../../app/service/PessoaService'
import AreaAtuacaoService from '../../app/service/AreaAtuacaoService'
import ObjetoAcaoProcessoService from '../../app/service/ObjetoAcaoProcessoService'
import EstadoService from '../../app/service/EstadoService'
import CidadeService from '../../app/service/CidadeService'
import PedidoService from '../../app/service/PedidoService'
import PedidoProcessoService from '../../app/service/PedidoProcessoService'
import UsuarioService from '../../app/service/UsuarioService'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import './processo.css'

class CadastrarProcesso extends React.Component {

  constructor(props) {
    super(props);

    this.processoService = new ProcessoService();
    this.grupoTrabalhoService = new GrupoTrabalhoService();
    this.tipoAcaoService = new TipoAcaoService();
    this.statusProcessualService = new StatusProcessualService();
    this.tipoDecisaoService = new TipoDecisaoService();
    this.objetoAcaoService = new ObjetoScaoService();
    this.pessoaService = new PessoaService();
    this.areaAtuacaoService = new AreaAtuacaoService();
    this.objetoAcaoProcessoService = new ObjetoAcaoProcessoService();
    this.estadoService = new EstadoService();
    this.cidadeService = new CidadeService();
    this.pedidoService = new PedidoService();
    this.pedidoProcessoService = new PedidoProcessoService();
    this.usuarioSevice = new UsuarioService();

    this.consultarPessoa = this.consultarPessoa.bind(this);
    this.consultarPessoaParteContraria = this.consultarPessoaParteContraria.bind(this);
    this.consultarPessoaAdvogados = this.consultarPessoaAdvogados.bind(this);
    this.onGrupoTrabalhoChange = this.onGrupoTrabalhoChange.bind(this);
    this.onAreaAtuacaoChange = this.onAreaAtuacaoChange.bind(this);
    this.onStatusProcessualChange = this.onStatusProcessualChange.bind(this);
    this.onTipoAcaoChange = this.onTipoAcaoChange.bind(this);
    this.onTipoDecisaoChange = this.onTipoDecisaoChange.bind(this);
    this.onChangeEstado = this.onChangeEstado.bind(this);
    this.onChangeCidade = this.onChangeCidade.bind(this);
    this.onChangeTipoPessoa = this.onChangeTipoPessoa.bind(this);
    this.acoesPedidos = this.acoesPedidos.bind(this);
    this.acoesObjetosAcao = this.acoesObjetosAcao.bind(this);
    this.onChangeObjetos = this.onChangeObjetos.bind(this);
    this.incluirParte = this.incluirParte.bind(this);
    this.acoesPartes = this.acoesPartes.bind(this);

    this.state = {
      //Cadastro de Processo
      processo: null,
      gruposTrabalho: [],
      grupoTrabalho: null,
      usuarios: [],
      responsavel: null,
      pasta: '',
      nrProcesso: '',
      nrCnj: '',
      instancia: null,
      dsComarca: '',
      tiposAcao: [],
      tipoAcao: null,
      statusProcessuais: [],
      statusProcessual: null,
      areasAtuacao: [],
      areaAtuacao: null,
      tiposDecisao: [],
      tipoDecisao: null,
      dataDistribuicao: null,
      objetosAcao: [],
      subObjetosAcao: [],
      objetoAcao: null,
      dsPedidos: '',
      observacao: '',
      pedido: null,
      vlPossivel: '',
      vlProavel: '',
      vlRemoto: '',
      vlCausa: '',
      pedidos: [],
      modalPedidos: false,
      contingenciaContabil: null,
      uf: null,
      tipoParte: null,
      orgaoColegiado: '',
      relator: '',
      //
      selectedAutor: null,
      selectedReu: null,
      selectedAdvogado: null,
      filterPessoas: null,
      filterPessoasParteContraria: null,
      filterPessoasAdvogados: null,
      pessoas: [],
      pessoasParteContraria: [],
      pessoasAdvogados: [],
      classeDiv: 'hide',
      detail: '',
      modalObjetos: false,
      selectSubObjetos: null,
      //Novo Cliente
      modalNovoCliente: false,
      nome: '',
      selectTipo: null,
      perfil: null,
      perfis: [],
      selectCidade: null,
      selectEstado: null,
      estados: [],
      cidades: [],
      openSpinner: false,
      exibeCpf: 'none',
      exibeCnpj: 'none',
      cpfPessoa: '',
      cnpjPessoa: '',
      //Atalhos de cadastros
      nomeGrupoTrabalho: '',
      descricaoGrupoTrabalho: '',
      modalGrupoTrabalho: false,
      exibirPartes: 'none',
      //Bancada
      bancadas: [],
      bancada: null,
      //Arquivar Processo
      //Arquivado
      exibeDatasStatusProcessual: 'none',
      dataArquivamento: '',
      dataArquivamentoTj: '',
      usuarioArquivou: '',
      isArquivar: false,
      resultadoArquivamento: false,
    };

    this.tiposPessoa = [
      {codigo: 'F', nome: 'Física'},
      {codigo: 'J', nome: 'Jurídica'}
    ];

    this.pedidosTemp = [];

    this.objetosProcesso = [];

    this.contingenciaContabil = [
      {codigo: 'PO', nome: 'Possível'},
      {codigo: 'PR', nome: 'Provável'},
      {codigo: 'RE', nome: 'Remoto'}
    ];

    this.estados = [
      {codigo: 'AC', nome: 'Acre'},
      {codigo: 'AL', nome: 'Alagoas'},
      {codigo: 'AM', nome: 'Amazonas'},
      {codigo: 'AP', nome: 'Amapá'},
      {codigo: 'BA', nome: 'Bahia'},
      {codigo: 'CE', nome: 'Ceará'},
      {codigo: 'DF', nome: 'Distrito Federal'},
      {codigo: 'ES', nome: 'Espírito Santo'},
      {codigo: 'GO', nome: 'Goiás'},
      {codigo: 'MA', nome: 'Maranhão'},
      {codigo: 'MG', nome: 'Minas Gerais'},
      {codigo: 'MS', nome: 'Mato Grosso do Sul'},
      {codigo: 'MT', nome: 'Mato Grosso'},
      {codigo: 'PA', nome: 'Pará'},
      {codigo: 'PB', nome: 'Paraíba'},
      {codigo: 'PE', nome: 'Pernambuco'},
      {codigo: 'PI', nome: 'Piauí'},
      {codigo: 'PR', nome: 'Paraná'},
      {codigo: 'RJ', nome: 'Rio de janeiro'},
      {codigo: 'RN', nome: 'Rio Grande do Norte'},
      {codigo: 'RO', nome: 'Rondônia'},
      {codigo: 'RR', nome: 'Roraima'},
      {codigo: 'RS', nome: 'Rio Grande do Sul'},
      {codigo: 'SC', nome: 'Santa Catarina'},
      {codigo: 'SE', nome: 'Sergipe'},
      {codigo: 'SP', nome: 'São Paulo'},
      {codigo: 'TO', nome: 'Tocantins'}
    ];

    this.tipoPartes = [
      {codigo: 'A', nome: 'Autor'},
      {codigo: 'R', nome: 'Réu'},
      {codigo: 'AD', nome: 'Advogado'},
      {codigo: 'EM', nome: 'Embargante'},
      {codigo: 'RE', nome: 'Reclamado'},
      {codigo: 'TE', nome: 'Testemunha'},
      {codigo: 'EN', nome: 'Envolvido'},
      {codigo: 'IN', nome: 'Inventariante'},
      {codigo: 'RC', nome: 'Reclamante'},
      {codigo: 'NO', nome: 'Notificado'},
      {codigo: 'NC', nome: 'Notificante'}
    ];

    this.instancias = [
      {codigo: 'primeiro grau', nome: 'Primeiro Grau'},
      {codigo: 'segundo grau', nome: 'Segundo Grau'},
      {codigo: 'superior', nome: 'Superior'}
    ];

    this.resultadoArquivamento = [
      {codigo: 'I', nome: 'Improcedente'},
      {codigo: 'P', nome: 'Procedente'},
      {codigo: 'E', nome: 'Extinto'},
      {codigo: 'A', nome: 'Acordo'}
    ];

    this.partesIncluidas = [];
  }

  listarUsuarios = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.usuarioSevice.listarUsuariosEmpresa(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({usuarios:response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Usuários', detail:'Erro ao listar usuários', life: 4000});
      })
  }

  incluirParte(e){
    if(this.state.selectedAutor == null) {
      this.toast.show({severity:'error', summary: 'Processo', detail:'Informe o nome da parte', life: 4000});
      this.setState({tipoParte: null});
      this.setState({selectedAutor: null});
      return;
    }
    this.setState({tipoParte: e.value})
    for(let i = 0; i < this.state.selectedAutor.length; i++) {
      const parteIncluir = {
        parte: this.state.selectedAutor[i],
        tipo: e.value
      }
      this.partesIncluidas.push(parteIncluir);
    }
    this.setState({selectedAutor: null});
    this.setState({tipoParte: null});
    this.setState({exibirPartes: 'block'});
  }

  acoesPartes(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir"
                onClick={() => this.excluirParte(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  excluirParte = (parte) => {
    for(let i = 0; i < this.partesIncluidas.length; i++) {
      if(parte.parte.codigo === this.partesIncluidas[i].parte.codigo) {
        this.partesIncluidas.splice(i,1);
        if(this.partesIncluidas.length == 0) {
          this.setState({exibirPartes: 'none'});
        }
        this.fecharModal('modalPedidos');
        return;
      }
    }
  }

  //Atalhos de cadastros
  novoGrupoTrabalho(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState({nomeGrupoTrabalho: ''});
    this.setState({descricaoGrupoTrabalho: ''});
    this.setState(state);
  }
  cadastrarGrupoTrabalho = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.nomeGrupoTrabalho == '') {
      this.toast.show({severity:'error', summary: 'Grupos de Trabalho', detail:'Informe o nome do Grupo de Trabalho', life: 4000});
      return;
    }
    const grupo = {
      nome: this.state.nomeGrupoTrabalho,
      descricao: this.state.descricaoGrupoTrabalho,
      empresa: usuarioLogado.empresa
    }
    this.grupoTrabalhoService.cadastrarGrupo(grupo)
      .then(response => {
        this.toast.show({severity:'error', summary: 'Grupos de Trabalho', detail:'Grupo de Trabalho cadastrado com sucesso!', life: 4000});
        this.listarGruposTrabalho(usuarioLogado);
        this.fecharModal('modalGrupoTrabalho');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Cadastro de nova Pessoa', detail:`${this.state.detail}`, life: 4000});
      })
  }

  limparCampos = () => {
    this.setState({
      grupoTrabalho: '',

    })
  }

  listarEstados = async () => {
    this.estadoService.listarEstados()
      .then(response => {
        this.setState({estados: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao listar Estados', life: 4000});
      });
  }

  async onChangeTipoPessoa(e) {
      if(e.value.codigo == 'F') {
        this.setState({exibeCpf: 'block'});
        this.setState({exibeCnpj: 'none'});
        this.setState({cpfPessoa: ''});
      } else {
        this.setState({exibeCpf: 'none'});
        this.setState({exibeCnpj: 'block'});
        this.setState({cnpjPessoa: ''});
      }
    this.setState({selectTipo: e.value});
  }

  async onChangeEstado(e) {
    await this.setState({selectEstado: e.value});
    this.listarCidades();
  }

  listarCidades = () => {
    this.cidadeService.listarCidades(this.state.selectEstado.codigo)
      .then(response => {
        this.setState({cidades: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao listar Cidades', life: 4000});
      })
  }

  onChangeCidade(e) {
    this.setState({selectCidade: e.value});
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  async abrirModalCadastroCliente(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    await this.setState({openSpinner: true});
    await this.listarEstados();
    this.setState({nome: ''});
    this.setState({selectTipo: null});
    this.setState({selectEstado: null});
    this.setState({selectCidade: null});
    this.setState({perfil: null});
    this.setState(state);
    this.setState({openSpinner: false});
  }

  async novoAutor() {
    this.setState({openSpinner: true});
    await this.listarPerfisPessoa();
    this.setState({exibeCnpj: 'none'});
    this.setState({exibeCpf: 'none'});
    this.abrirModalCadastroCliente('modalNovoCliente');
    this.setState({openSpinner: false});
  }

  async novoReu() {
    await this.listarPerfisPessoa();
    this.abrirModalCadastroCliente('modalNovoCliente');
  }

  async novoAdvogado() {
    await this.listarPerfisPessoa();
    this.abrirModalCadastroCliente('modalNovoCliente');
  }

  listarPerfisPessoa = async () => {
    await this.pessoaService.listarPerfilPessoa()
      .then(response => {
        this.setState({perfis: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Pessoas', detail:'Erro ao listar tipos de perfis de pessoa', life: 4000});
      })
  }

  cadastrarNovoCliente = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;

    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Cadastro de nova Pessoa', detail:'Informe o nome da Pessoa', life: 4000});
      return false;
    }

    if(this.state.selectTipo == null || this.state.selectTipo.codigo == null) {
      this.toast.show({severity:'error', summary: 'Cadastro de nova Pessoa', detail:'Informe o Tipo de Pessoa', life: 4000});
      return false;
    }

    if(this.state.selectTipo.codigo == 'F') {
      if(this.state.cpfPessoa == '') {
        this.toast.show({severity:'error', summary: 'Cadastro de nova Pessoa', detail:'Informe o CPF da Pessoa', life: 4000});
        return false;
      }
    }

    if(this.state.selectTipo.codigo == 'J') {
      if(this.state.cnpjPessoa == '') {
        this.toast.show({severity:'error', summary: 'Cadastro de nova Pessoa', detail:'Informe o CNPJ da Pessoa', life: 4000});
        return false;
      }
    }

    if(this.state.selectCidade == null || this.state.selectCidade.codigo == null) {
      this.toast.show({severity:'error', summary: 'Cadastro de nova Pessoa', detail:'Informe a Cidade', life: 4000});
      return false;
    }

    if(this.state.perfil == null) {
      this.toast.show({severity:'error', summary: 'Cadastro de nova Pessoa', detail:'Informe o perfil da pessoa', life: 4000});
      return false;
    }

    var cpfCnpj = '';
    if(this.state.selectTipo.codigo = 'F') {
      cpfCnpj = this.state.cpfPessoa;
    } else {
      cpfCnpj = this.state.cnpjPessoa;
    }

    this.setState({openSpinner: true});
    await this.pessoaService.cadastrarPessoaProcesso({
      nome: this.state.nome,
      tipoPessoa: this.state.selectTipo.codigo,
      cpfCnpj: cpfCnpj,
      perfil: this.state.perfil,
      cidade: this.state.selectCidade,
      empresa: usuarioLogado.empresa,
      usuario: usuarioLogado.codigo
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Cadastro de nova Pessoa', detail:'Nova Pessoa cadastrada com sucesso', life: 4000});
      this.fecharModal('modalNovoCliente');
      this.listarPessoasEmpresaPartes();
    }).catch(error => {
      this.setState(error.response.data);
      this.setState({openSpinner: false});
      this.toast.show({severity:'error', summary: 'Cadastro de nova Pessoa', detail:`${this.state.detail}`, life: 4000});
    });
    this.setState({openSpinner: false});
  }

  carregaCombosConsulta = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    this.listarGruposTrabalho(usuarioLogado);
    this.listarTiposAcao(usuarioLogado.empresa);
    this.listarStatusProcessual(usuarioLogado.empresa);
    this.listarTiposDecisao(usuarioLogado.empresa);
    this.listarAreaAtuacao(usuarioLogado.empresa);
    this.listarUsuarios();
    this.listarBancadas();
  }

  listarGruposTrabalho = (usuario) => {
    this.grupoTrabalhoService.listarGruposUsuario(usuario.codigo)
      .then(response => {
        this.setState({gruposTrabalho: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Grupos de Trabalhos do usuário', life: 4000});
      });
  }

  listarTiposAcao = (empresa) => {
    this.tipoAcaoService.listarTipoAcao(empresa.codigo)
      .then(response => {
        this.setState({tiposAcao: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Tipos de Ação', life: 4000});
      })
  }

  listarStatusProcessual = (empresa) => {
    this.statusProcessualService.listarStatusProcessual(empresa.codigo)
      .then(response => {
        this.setState({statusProcessuais: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Status Processual', life: 4000});
      })
  }

  listarTiposDecisao = (empresa) => {
    this.tipoDecisaoService.listarTiposDecisao(empresa.codigo)
      .then(response => {
        this.setState({tiposDecisao: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Tipos de Decisão', life: 4000});
      })
  }

  listarObjetosAcao = (empresa) => {
    this.objetoAcaoService.listarObjetos(empresa.codigo)
      .then(response => {
        this.setState({objetosAcao: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Objetos de Ação', life: 4000});
      })
  }

  listarSubObjetosAcao = (codigo) => {
    this.objetoAcaoService.listarSubObjetos(codigo)
      .then(response => {
        this.setState({subObjetosAcao: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Sub-Objetos de Ação', life: 4000});
      })
  }

  async onChangeObjetos(e) {
    this.setState({openSpinner: true});
    await this.setState({objetoAcao: e.value});
    await this.listarSubObjetosAcao(this.state.objetoAcao.codigo);
    this.setState({openSpinner: false});
  }

  listarAreaAtuacao = (empresa) => {
    this.areaAtuacaoService.listarAreaAtuacao(empresa.codigo)
      .then(response => {
        this.setState({areasAtuacao: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Áreas de Atuação', life: 4000});
      })
  }

  listarPessoasEmpresaParteCliente = async() => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.pessoaService.listarPessoasEmpresaPerfil(usuarioLogado.empresa.codigo, 'CL')
      .then(response => {
        this.setState({pessoas: response.data});
      }).catch(error => {
        console.log('Erro ao carregar pessoas');
      })
  }

  listarPessoasEmpresaParteContraria = async() => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.pessoaService.listarPessoasEmpresaPerfil(usuarioLogado.empresa.codigo, 'PC')
      .then(response => {
        this.setState({pessoasParteContraria: response.data});
      }).catch(error => {
        console.log('Erro ao carregar pessoas');
      })
  }

  listarPessoasEmpresaPartes = async() => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.pessoaService.listarPessoas(usuarioLogado.empresa.codigo)
      .then(response => {
				console.log('Pessoas ', response.data);
        this.setState({pessoas: response.data});
      }).catch(error => {
        console.log('Erro ao carregar pessoas');
      })
  }

  listarPessoasEmpresaAdvogados = async() => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.pessoaService.listarPessoasEmpresaPerfil(usuarioLogado.empresa.codigo, 'AD')
      .then(response => {
        this.setState({pessoasAdvogados: response.data});
      }).catch(error => {
        console.log('Erro ao carregar pessoas');
      })
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    await this.listarPessoasEmpresaPartes();
    await this.carregaCombosConsulta();
    this.setState({openSpinner: false});
  }

  consultarPessoa(event) {
    setTimeout(() => {
        let filterPessoas;
        if (!event.query.trim().length) {
            filterPessoas = [...this.state.pessoas];
        }
        else {
            filterPessoas = this.state.pessoas.filter((pessoa) => {
                return pessoa.nome.toLowerCase().startsWith(event.query.toLowerCase());
            });
        }

        this.setState({ filterPessoas });
    }, 250);
  }

  consultarPessoaParteContraria(event) {
    setTimeout(() => {
        let filterPessoasParteContraria;
        if (!event.query.trim().length) {
          filterPessoasParteContraria = [...this.state.pessoas];
        }
        else {
          filterPessoasParteContraria = this.state.pessoas.filter((pessoa) => {
                return pessoa.nome.toLowerCase().startsWith(event.query.toLowerCase());
            });
        }

        this.setState({ filterPessoasParteContraria });
    }, 250);
  }

  consultarPessoaAdvogados(event) {
    setTimeout(() => {
        let filterPessoasAdvogados;
        if (!event.query.trim().length) {
          filterPessoasAdvogados = [...this.state.pessoas];
        }
        else {
          filterPessoasAdvogados = this.state.pessoas.filter((pessoa) => {
                return pessoa.nome.toLowerCase().startsWith(event.query.toLowerCase());
            });
        }

        this.setState({ filterPessoasAdvogados });
    }, 250);
  }

  onGrupoTrabalhoChange(e) {
    this.setState({grupoTrabalho: e.value});
  }

  onStatusProcessualChange(e) {
    if(e.value != null) {
      if(e.value.descricao == 'Arquivado') {
        this.setState({isArquivar: true});
        this.setState({exibeDatasStatusProcessual: 'block'});
        this.setState({resultadoArquivamento: false});
      } else {
        this.setState({isArquivar: false});
        this.setState({exibeDatasStatusProcessual: 'none'});
      }
    } else {
      this.setState({isArquivar: false});
      this.setState({exibeDatasStatusProcessual: 'none'});
    }
    this.setState({statusProcessual: e.value});
  }

  onAreaAtuacaoChange(e) {
    this.setState({areaAtuacao: e.value});
  }

  onTipoAcaoChange(e) {
    this.setState({tipoAcao: e.value});
  }

  onTipoDecisaoChange(e) {
    this.setState({tipoDecisao: e.value});
  }

  pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  cadastrarProcesso = async() => {
    if(this.state.responsavel == null) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Informe o Responsável do Processo', life: 4000});
      return false;
    }

    if(this.partesIncluidas.length == 0) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Nenhuma parte foi informada', life: 4000});
      return false;
    }
    
    if(this.state.numeroCnj == '' && this.pasta == '' && this.state.numeroProcesso) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'É preciso informar uma pasta ou um processo ou um cnj', life: 4000});
      return false;
    }

    if(this.state.grupoTrabalho == null) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'É preciso inform o Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.statusProcessual == null) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Informe o Status Processual', life: 4000});
      return false;
    }

    if(this.state.areaAtuacao == null) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Informe a Área de Atuação', life: 4000});
      return false;
    }

    if(this.state.tipoAcao == null) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Informe o Tipo de Ação', life: 4000});
      return false;
    }

    if(this.state.dsComarca == '') {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Informe o local de trâmite', life: 4000});
      return false;
    }

    if(this.state.isArquivar) {
      if(this.state.resultadoArquivamento == null) {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Você selecionou o status processual como Arquivado. Informe o resultado do arquivamento', life: 4000});
        return false;
      }
    }

    const usuarioLogado = this.context.usuarioAutenticado;

    //Data de Distribuição
    var dataFormatadaDistribuicao = '';
    if(this.state.dataDistribuicao != null) {
      var date = this.state.dataDistribuicao;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaDistribuicao =  year+"-"+month+"-"+day;
    }

    var uf = null;
    if(this.state.uf == null) {
      uf = null;
    } else {
      uf = this.state.uf.codigo;
    }
    
    let partes = [];
    for(let i = 0; i < this.partesIncluidas.length; i++) {
      const parte = {
        pessoa: this.partesIncluidas[i].parte,
        processo: null,
        tipo: this.partesIncluidas[i].tipo.codigo
      }
      partes.push(parte);
    }

    var inst = null;
    if(this.state.instancia == null) {
      inst = null;
    } else {
      inst = this.state.instancia.codigo;
    }

    var processoArquivado = null;
    if(this.state.isArquivar) {
      //Data de Arquivamento
      var date = this.state.dataArquivamento;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      var dataFormatadaArquivamento =  year+"-"+month+"-"+day;

      //Data de Arquivamento do Tribunal
      var dataFormatadaDataArquivamentoTj = null;
      if(this.state.dataArquivamentoTj != '' && this.state.dataArquivamentoTj != null) {
        var date = this.state.dataArquivamentoTj;
        var month = this.pad2(date.getMonth()+1);//months (0-11)
        var day = this.pad2(date.getDate());//day (1-31)
        var year= date.getFullYear();
        dataFormatadaDataArquivamentoTj =  year+"-"+month+"-"+day;
      }

      processoArquivado = {
        resultadoArquivamento: this.state.resultadoArquivamento.codigo,
        dataArquivadoTribunal: dataFormatadaDataArquivamentoTj
      }
    }

    this.setState({openSpinner: true});
    await this.processoService.cadastrarProcesso({
      grupoTrabalho: this.state.grupoTrabalho,
      pasta: this.state.pasta,
      nrProcesso: this.state.nrProcesso,
      nrCnj: this.state.nrCnj,
      nrInstancia: inst,
      dsComarca: this.state.dsComarca,
      tipoAcao: this.state.tipoAcao,
      statusProcessual: this.state.statusProcessual,
      areaAtuacao: this.state.areaAtuacao,
      tipoDecisao: this.state.tipoDecisao,
      dataDistribuicao: dataFormatadaDistribuicao,
      vlProvavel: this.state.vlProvavel,
      vlPossivel: this.state.vlPossivel,
      vlRemoto: this.state.vlRemoto,
      vlCausa: this.state.vlCausa,
      dsPedidos: this.state.dsPedidos,
      observacao: this.state.observacao,
      usuario: usuarioLogado,
      responsavel: this.state.responsavel,
      empresa: usuarioLogado.empresa,
      partes: partes,
      pedidos: this.pedidosTemp,
      objetos: this.objetosProcesso,
      uf: uf,
      orgaoColegiado: this.state.orgaoColegiado,
      relator: this.state.relator,
      bancada: this.state.bancada,
      processoArquivado: processoArquivado
    }).then(response => {
       this.setState({processo: response.data});
       this.processoCadastrado(this.state.processo);
    }).catch(error => {
      this.setState(error.response.data)
      this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
    });

    this.setState({openSpinner: false});
  }

  processoCadastrado = async (processo) => {
    const action = 'NEW';
    await this.props.history.push(`/fichaProcesso/${processo.codigo}/${action}`);
  }

  voltar = () => {
    this.props.history.push('/processos')
  }

  listarPedidos = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.pedidoService.listarPedidos(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({pedidos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async abrirModalPedidos(name, position) {
    this.setState({openSpinner: true});
    await this.listarPedidos();
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCampospedidos();
    this.setState({openSpinner: false});
    this.setState(state);
  }

  limparCampospedidos = () => {
    this.setState({pedido: null});
    this.setState({vlProvavel: null});
    this.setState({vlPossivel: null});
    this.setState({vlRemoto: null});
  }

  incluirPedido = () => {
    if(this.state.pedido == null) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'O pedido é obrigatório', life: 4000});
      return;
    }

    const pedidoProcesso = {
      pedido: this.state.pedido,
      vlPossivel: this.state.vlPossivel.toLocaleString('pt-br', {minimumFractionDigits: 2}),
      vlProvavel: this.state.vlProvavel.toLocaleString('pt-br', {minimumFractionDigits: 2}),
      vlRemoto: this.state.vlRemoto.toLocaleString('pt-br', {minimumFractionDigits: 2})
    };
    this.pedidosTemp.push(pedidoProcesso);
    this.fecharModal('modalPedidos');
  }

  acoesPedidos(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Pedido"
                onClick={() => this.excluirPedido(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  excluirPedido = (pedido) => {
    for(let i = 0; i < this.pedidosTemp.length; i++) {
      if(pedido.pedido.codigo === this.pedidosTemp[i].pedido.codigo) {
        this.pedidosTemp.splice(i,1);
        this.fecharModal('modalPedidos');
        return;
      }
    }
  }

  incluirObjeto = () => {
    if(this.state.selectSubObjetos == null && this.state.objetoAcao == null) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'É preciso informar algum Objeto de Ação', life: 4000});
      return;
    }
   
    let objeto = null;

    if(this.state.objetoAcao != null) {
      objeto = {
        codigo: this.state.objetoAcao.codigo,
        nome: this.state.objetoAcao.nome
      }
      
      this.objetosProcesso.push(objeto);
    }

    if(this.state.selectSubObjetos != null) {
      for(let i = 0; i < this.state.selectSubObjetos.length; i++) {
        objeto = {
          codigo: this.state.selectSubObjetos[i].codigo,
          nome: this.state.selectSubObjetos[i].nome
        }
        this.objetosProcesso.push(objeto);
      }
    }

    this.fecharModal('modalObjetos');
  }

  async abrirModalObjetos(name, position) {
    this.setState({openSpinner: true});
    const usuarioLogado = this.context.usuarioAutenticado;
    this.listarObjetosAcao(usuarioLogado.empresa);
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState({openSpinner: false});
    this.setState(state);
  }

  acoesObjetosAcao(rowData) {
    return (
      <React.Fragment>
       <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
               tooltip="Retirar Objeto"
               tooltipOptions={{position: 'top'}}
               onClick={() => this.excluirObjeto(rowData)}
               style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  excluirObjeto = (objeto) => {
    for(let i = 0; i < this.objetosProcesso.length; i++) {
      if(objeto.codigo === this.objetosProcesso[i].codigo) {
        this.objetosProcesso.splice(i,1);
        this.fecharModal('modalPedidos');
        return;
      }
    }
  }

  listarBancadas = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.pessoaService.listarBancadas(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({bancadas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }
  
  render() {
    addLocale('es', {
      firstDayOfWeek: 1,
      dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
      dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
      dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
      monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'Dezembro'],
      monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
      today: 'Hoy',
      clear: 'Claro'
    });
  
    locale('es');

    const usuarioLogado = this.context.usuarioAutenticado;
    const usuarioPerfil = usuarioLogado.perfil.codigo;
    var adm = 'none';
    if(usuarioPerfil == 1) {
      adm = 'hide';
    }

    var camposFama = "";
    var camposOutros = "";

    if(usuarioLogado.empresa.codigo == 142) {
      camposFama = 'hide';
      camposOutros = 'none';
    }

    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          <div className="container-fluid">
              <section className="content-header">
                <div className="card card-primary card-outline">
                  <div className="card-header">
                    <h3 className="card-title">
                      <i className="fas fa-users"></i>
                      <span> Incluir Processo</span>
                    </h3>  
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-8">
                        <div className="form-group">
                          <label>Partes<span className="obrigatorioAsterisco"> *</span></label>
                          <AutoComplete value={this.state.selectedAutor}
                                        suggestions={this.state.filterPessoas} 
                                        completeMethod={this.consultarPessoa}
                                        style={{width: '152%'}}
                                        field="nome" multiple onChange={(e) => this.setState({selectedAutor: e.value })} 
                                        className="p-autoComplete-sm p-d-block p-mb-0"/>
                        <a className="linkCadastroNovoCliente" onClick={() => this.novoAutor()}>Cadastrar novo cliente
                        </a>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-8">
                        <div className="form-group">
                          <label>Tipo<span className="obrigatorioAsterisco"> *</span></label>
                          <Dropdown value={this.state.tipoParte} 
                                    options={this.tipoPartes} style={{width: '100%', height: '32px'}}
                                    optionLabel="nome" 
                                    filter showClear filterBy="nome"
                                    onChange={this.incluirParte} 
                                    id="tipoParte"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row" style={{display: `${this.state.exibirPartes}`}}>
                      <div className="col-sm-8">
                        <div className="form-group">
                          <DataTable value={this.partesIncluidas} emptyMessage="Partes incluídas" size="small">
                            <Column field="parte.nome" header="Nome"></Column>
                            <Column field="tipo.nome"  header="Tipo"></Column>
                            <Column body={this.acoesPartes} exportable={false} style={{ minWidth: '8rem' }}></Column>
                          </DataTable>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-8">
                        <div className="form-group">
                          <hr></hr>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Responsável pelo Processo</label>
                          <Dropdown value={this.state.responsavel} 
                                    options={this.state.usuarios} style={{width: '100%', height: '32px'}}
                                    optionLabel="nome" 
                                    filter showClear filterBy="nome"
                                    onChange={e => this.setState({responsavel: e.target.value})}
                                    id="responsavel"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Bancada de Advogados</label>
                          <Dropdown value={this.state.bancada} 
                                    options={this.state.bancadas} style={{width: '100%', height: '32px'}}
                                    optionLabel="nome" 
                                    emptyMessage="Nenhuma bancada cadastrada"
                                    filter showClear filterBy="nome"
                                    onChange={e => this.setState({bancada: e.target.value})}
                                    id="bancada"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>Pasta</label>
                          <InputText id="pasta" 
                                     type="text" 
                                     style={{width: '100%', height: '32px'}}
                                     value={this.state.pasta}
                                     onChange={e => this.setState({pasta: e.target.value})}
                                     className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label>UF</label>
                          <Dropdown value={this.state.uf} 
                                    options={this.estados} style={{width: '100%', height: '32px'}}
                                    optionLabel="nome" 
                                    filter showClear filterBy="nome"
                                    onChange={e => this.setState({uf: e.target.value})}
                                    id="uf"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Processo Judicial</label>
                          <InputMask id="numeroCnj" 
                                     type="text" 
                                     mask="9999999-99.9999.9.99.9999"
                                     style={{width: '100%', height: '32px'}} 
                                     value={this.state.nrCnj}
                                     onChange={e => this.setState({nrCnj: e.target.value})}
                                     className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Processo Administrativo</label>
                          <InputText id="numeroProcesso" 
                                     type="text" 
                                     style={{width: '100%', height: '32px'}} 
                                     value={this.state.nrProcesso}
                                     onChange={e => this.setState({nrProcesso: e.target.value})}
                                     className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Grupo de Trabalho
                            <span className="obrigatorioAsterisco"> * </span>
                            <span style={{display: `${adm}`}}>
                              <Button icon="pi pi-plus-circle" className="p-button-rounded p-button-text"
                                      tooltip="Clique para adicionar um novo Grupo de Trabalho" 
                                      tooltipOptions={{position: 'top'}}
                                      data-toggle="modal" 
                                      onClick={() => this.novoGrupoTrabalho('modalGrupoTrabalho')}
                                      data-target="#modal-default"
                                      style={{width: '20px', height: '10px'}}/>
                            </span>
                          </label>
                          <Dropdown value={this.state.grupoTrabalho} 
                                    options={this.state.gruposTrabalho} style={{width: '100%', height: '32px'}}
                                    optionLabel="nome" 
                                    filter showClear filterBy="nome"
                                    onChange={this.onGrupoTrabalhoChange}
                                    id="grupoTrabalho"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Status Processual
                            <span className="obrigatorioAsterisco"> * </span>
                            <span style={{display: `${adm}`}}>
                              <Button icon="pi pi-plus-circle" className="p-button-rounded p-button-text"
                                      tooltip="Clique para adicionar um Novo Status Processual" 
                                      tooltipOptions={{position: 'top'}}
                                      style={{width: '20px', height: '10px'}}/>
                            </span>
                          </label>
                          <Dropdown value={this.state.statusProcessual} 
                                    options={this.state.statusProcessuais} style={{width: '100%', height: '32px'}}
                                    optionLabel="descricao" 
                                    filter showClear filterBy="descricao"
                                    onChange={this.onStatusProcessualChange}
                                    id="statusProcessual"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div style={{display: `${this.state.exibeDatasStatusProcessual}`}}>
                      <div className="row">
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Dt. Arquivamento Tribunal</label>
                            <Calendar id="dataArquivamentotj"
                                      value={this.state.dataArquivamentoTj} 
                                      onChange={(e) => this.setState({ dataArquivamentoTj: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Resultado do Arquivamento</label>
                            <Dropdown value={this.state.resultadoArquivamento} 
                                      options={this.resultadoArquivamento} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      filter showClear filterBy="nome"
                                      onChange={(e) => this.setState({ resultadoArquivamento: e.value })} 
                                      id="resultadoArquivamento"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Área de Atuação
                            <span className="obrigatorioAsterisco"> * </span>
                            <span style={{display: `${adm}`}}>
                              <Button icon="pi pi-plus-circle" className="p-button-rounded p-button-text"
                                      tooltip="Clique para adicionar uma nova Área de Atuação" 
                                      tooltipOptions={{position: 'top'}}
                                      style={{width: '20px', height: '10px'}}/>
                            </span>
                          </label>
                          <Dropdown value={this.state.areaAtuacao} 
                                    options={this.state.areasAtuacao} style={{width: '100%', height: '32px'}}
                                    optionLabel="nome" 
                                    filter showClear filterBy="nome"
                                    onChange={this.onAreaAtuacaoChange}
                                    id="areaAtuacao"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Tipo de Ação
                            <span className="obrigatorioAsterisco"> * </span>
                            <span style={{display: `${adm}`}}>
                              <Button icon="pi pi-plus-circle" className="p-button-rounded p-button-text"
                                      tooltip="Clique para adicionar um Novo Tipo de Ação" 
                                      tooltipOptions={{position: 'top'}}
                                      style={{width: '20px', height: '10px'}}/>
                            </span>
                          </label>
                          <Dropdown value={this.state.tipoAcao} 
                                    options={this.state.tiposAcao} style={{width: '100%', height: '32px'}}
                                    optionLabel="nome" 
                                    filter showClear filterBy="nome"
                                    onChange={this.onTipoAcaoChange}
                                    id="tipoAcao"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                     <div className="row">
                      <div className="col-sm-8">
                        <div className="form-group">
                          <label>Comarca
                            <span className="obrigatorioAsterisco"> * </span>
                          </label>
                          <InputText id="comarca" 
                                     type="text" 
                                     style={{width: '100%', height: '32px'}} 
                                     value={this.state.dsComarca}
                                     onChange={e => this.setState({dsComarca: e.target.value})}
                                     className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row"> 
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Orgão Colegiado</label>
                          <InputText id="orgaoColegiado" 
                                     type="text" 
                                     style={{width: '100%', height: '32px'}} 
                                     value={this.state.orgaoColegiado}
                                     onChange={e => this.setState({orgaoColegiado: e.target.value})}
                                     className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Relator</label>
                          <InputText id="relator" 
                                     type="text" 
                                     style={{width: '100%', height: '32px'}} 
                                     value={this.state.relator}
                                     onChange={e => this.setState({relator: e.target.value})}
                                     className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label>Vl. Provável</label>
                          <InputNumber inputId="vlProvavel" 
                                       value={this.state.vlProavel} 
                                       style={{width: '100%', height: '32px'}} 
                                       onChange={(e) => this.setState({vlProvavel: e.value})} 
                                       mode="decimal" locale="de-BR" minFractionDigits={2}/>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label>Vl. Possível</label>
                          <InputNumber inputId="vlPossivel" 
                                       value={this.state.vlPossivel} 
                                       style={{width: '100%', height: '32px'}} 
                                       onChange={(e) => this.setState({vlPossivel: e.value})} 
                                       mode="decimal" locale="de-BR" minFractionDigits={2}/>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label>Vl. Remoto</label>
                          <InputNumber inputId="vlRemoto" 
                                       value={this.state.vlRemoto} 
                                       style={{width: '100%', height: '32px'}} 
                                       onChange={(e) => this.setState({vlRemoto: e.value})} 
                                       mode="decimal" locale="de-BR" minFractionDigits={2}/>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label>Vl. Causa</label>
                          <InputNumber inputId="vlCausa" 
                                       value={this.state.vlCausa} 
                                       style={{width: '100%', height: '32px'}} 
                                       onChange={(e) => this.setState({vlCausa: e.value})} 
                                       mode="decimal" locale="de-BR" minFractionDigits={2}/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Data de Distribuição</label>
                          <Calendar id="mask" 
                                    value={this.state.dataDistribuicao} 
                                    onChange={(e) => this.setState({ dataDistribuicao: e.value })} 
                                    style={{width: '100%', height: '32px'}} 
                                    dateFormat="dd/mm/yy"
                                    mask="99/99/9999"/>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Contingência Contábil</label>
                          <Dropdown value={this.state.contingenciaContabil} 
                                    options={this.contingenciaContabil} style={{width: '100%', height: '32px'}}
                                    optionLabel="nome" 
                                    filter showClear filterBy="nome"
                                    onChange={(e) => this.setState({contingenciaContabil: e.value})} 
                                    id="grupoTrabalho"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-8">
                        <div className="form-group">
                          <Accordion multiple>
                            <AccordionTab header="Pedidos">
                              <DataTable value={this.pedidosTemp} emptyMessage=" ">
                                <Column field="pedido.nome" header="Pedido"></Column>
                                <Column field="vlProvavel" header="Vl. Provável"></Column>
                                <Column field="vlPossivel" header="Vl. Possível"></Column>
                                <Column field="vlRemoto" header="Vl. Remoto"></Column>
                                <Column body={this.acoesPedidos} exportable={false} style={{ minWidth: '8rem' }}header={
                                    <Button icon="pi pi-plus" className="p-button-rounded p-button-text"
                                    tooltip="Clique para adicionar um novo Pagamento" 
                                    tooltipOptions={{position: 'top'}}
                                    style={{width: '20px', height: '20px'}}
                                    data-toggle="modal" 
                                    onClick={() => this.abrirModalPedidos('modalPedidos')}
                                    data-target="#modal-default"/>
                                }></Column>
                              </DataTable>
                            </AccordionTab>
                            <AccordionTab header="Objetos de Ação">
                              <DataTable value={this.objetosProcesso} emptyMessage=" ">
                                <Column field="nome" header="Objeto"></Column>
                                <Column body={this.acoesObjetosAcao} exportable={false} style={{ minWidth: '8rem' }}header={
                                    <Button icon="pi pi-plus" className="p-button-rounded p-button-text"
                                    tooltip="Clique para adicionar um novo Pagamento" 
                                    tooltipOptions={{position: 'top'}}
                                    style={{width: '20px', height: '20px'}}
                                    data-toggle="modal" 
                                    onClick={() => this.abrirModalObjetos('modalObjetos')}
                                    data-target="#modal-default"/>
                                }></Column>
                              </DataTable>
                            </AccordionTab>
                          </Accordion>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-8">
                        <div className="form-group">
                          <label>Observação</label>
                          <InputTextarea id="pedidos" 
                                         type="text" 
                                         style={{width: '100%'}} 
                                         value={this.state.observacao}
                                         onChange={e => this.setState({observacao: e.target.value})}
                                         className="p-inputtext-sm p-d-block p-mb-1"
                                         rows={4} cols={30}/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                      <div className="col-sm-8">
                        <div className="form-group">
                          <div style={{textAlign: 'right'}}>
                            <Button label="Cadastrar" 
                                    className="p-button-primary p-button-text"
                                    onClick={this.cadastrarProcesso}/> 
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

               {/**Cadastrar um novo cliente */}
               <Dialog header="Cadastrar nova Pessoa"
                       visible={this.state.modalNovoCliente} 
                       style={{ width: '40vw' }} 
                       footer={
                         <div>
                            <Button label="Cadastrar" 
                                    className="p-button-primary p-button-text" 
                                    onClick={this.cadastrarNovoCliente}/>
                            &nbsp;
                            <Button label="Fechar" 
                                    className="p-button-secondary p-button-text"
                                    onClick={() => this.fecharModal('modalNovoCliente')}/>
                          </div>
                       }
                       onHide={() => this.fecharModal('modalNovoCliente')}>

                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="descricaoArquivo">Nome<span className="obrigatorioAsterisco"> *</span></label>
                        <InputText id="nome"
                                   autoComplete="nope"
                                   type="text" 
                                   style={{width: '100%'}} 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>Tipo de Pessoa<span className="obrigatorioAsterisco"> *</span></label>
                        <Dropdown value={this.state.selectTipo} 
                                  options={this.tiposPessoa} style={{width: '100%', height: '32px'}}
                                  optionLabel="nome" 
                                  onChange={this.onChangeTipoPessoa}
                                  id="tipo"
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                      <div className="col-sm-6" style={{display: `${this.state.exibeCpf}`}}>
                        <div className="form-group">
                          <label>CPF<span className="obrigatorioAsterisco"> *</span></label>
                          <InputMask value={this.state.cpfPessoa}
                                     style={{width: '100%'}} 
                                     mask="999.999.999-99"
                                     id="idCpfPessoa"
                                     onChange={e => this.setState({cpfPessoa: e.target.value})}
                                     className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-6" style={{display: `${this.state.exibeCnpj}`}}>
                        <div className="form-group">
                          <label>CNPJ<span className="obrigatorioAsterisco"> *</span></label>
                          <InputMask value={this.state.cnpjPessoa}
                                     style={{width: '100%'}} 
                                     mask="99.999.999/9999-99"
                                     id="idCnpjPessoa"
                                     onChange={e => this.setState({cnpjPessoa: e.target.value})}
                                     className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label>Perfil<span className="obrigatorioAsterisco"> *</span></label>
                        <Dropdown value={this.state.perfil} 
                                  options={this.state.perfis} style={{width: '100%', height: '32px'}}
                                  optionLabel="nome" 
                                  onChange={e => this.setState({perfil: e.target.value})}
                                  id="perfil"
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label>Estado<span className="obrigatorioAsterisco"> *</span></label>
                        <Dropdown value={this.state.selectEstado} 
                                  options={this.state.estados} style={{width: '100%', height: '32px'}}
                                  optionLabel="estado"
                                  filter showClear filterBy="estado"
                                  onChange={this.onChangeEstado}
                                  id="estado"
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                    <div className="col-sm-9">
                      <div className="form-group">
                        <label>Cidade<span className="obrigatorioAsterisco"> *</span></label>
                        <Dropdown value={this.state.selectCidade} 
                                  options={this.state.cidades} style={{width: '100%', height: '32px'}}
                                  optionLabel="nome"
                                  filter showClear filterBy="nome" 
                                  emptyMessage=" "
                                  onChange={this.onChangeCidade}
                                  id="cidade"
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                </Dialog>

                {/**Cadastrar Pedidos do Processo */}
                <Dialog header="Cadastrar Pedidos"
                        visible={this.state.modalPedidos} 
                        
                        footer={
                          <div>
                              <Button label="Cadastrar" 
                                      className="p-button-primary p-button-text" 
                                      onClick={this.incluirPedido}/>
                              &nbsp;
                              <Button label="Fechar" 
                                      className="p-button-secondary p-button-text"
                                      onClick={() => this.fecharModal('modalPedidos')}/>
                            </div>
                        }
                        onHide={() => this.fecharModal('modalPedidos')}>

                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label htmlFor="descricaoArquivo">Pedido<span className="obrigatorioAsterisco"> *</span></label>
                            <Dropdown value={this.state.pedido} 
                                      options={this.state.pedidos} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      onChange={e => this.setState({pedido: e.target.value})}
                                      id="pedido"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Valor Provável</label>
                            <InputNumber inputId="locale-german" 
                                        value={this.state.vlProvavel} 
                                        style={{width: '100%', height: '32px'}} 
                                        onChange={(e) => this.setState({vlProvavel: e.value})} 
                                        mode="decimal" locale="de-BR" minFractionDigits={2}/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Valor Possível</label>
                            <InputNumber inputId="locale-german" 
                                        value={this.state.vlPossivel} 
                                        style={{width: '100%', height: '32px'}} 
                                        onChange={(e) => this.setState({vlPossivel: e.value})} 
                                        mode="decimal" locale="de-BR" minFractionDigits={2}/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Valor Remoto</label>
                            <InputNumber inputId="locale-german" 
                                        value={this.state.vlRemoto} 
                                        style={{width: '100%', height: '32px'}} 
                                        onChange={(e) => this.setState({vlRemoto: e.value})} 
                                        mode="decimal" locale="de-BR" minFractionDigits={2}/>
                          </div>
                        </div>
                      </div>
                  </Dialog>
                  {/**Cadastrar Objetos de Ação */}
                  <Dialog header="Cadastrar Objetos de Ação"
                      visible={this.state.modalObjetos} 
                      style={{ width: '40vw' }} 
                      footer={
                        <div>
                            <Button label="Incluir" 
                                    className="p-button-primary p-button-text" 
                                    onClick={this.incluirObjeto}/>
                            &nbsp;
                            <Button label="Fechar" 
                                    className="p-button-secondary p-button-text"
                                    onClick={() => this.fecharModal('modalObjetos')}/>
                          </div>
                      }
                      onHide={() => this.fecharModal('modalObjetos')}>

                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label htmlFor="descricaoArquivo">Objeto Principal<span className="obrigatorioAsterisco"> *</span></label>
                          <Dropdown value={this.state.objetoAcao} 
                                    options={this.state.objetosAcao} style={{width: '100%', height: '32px'}}
                                    optionLabel="nome" 
                                    onChange={this.onChangeObjetos}
                                    id="objeto"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                        <div className="form-group">
                          <label htmlFor="descricaoArquivo">Sub-Objetos<span className="obrigatorioAsterisco"> *</span></label>
                          <DataTable value={this.state.subObjetosAcao}
                                      selection={this.state.selectSubObjetos} onSelectionChange={(e) => this.setState({ selectSubObjetos: e.value })}
                                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                      emptyMessage=" "
                                      currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={5}>
                            <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} exportable={false}></Column>
                            <Column field="nome" header="Sub-Objeto"></Column>
                          </DataTable>
                        </div>
                      </div>
                    </div>
                  </Dialog>

                  {/**Atalhos de cadastros */}
                  <Dialog header="Cadastro de Grupo de Trabalho"
                          visible={this.state.modalGrupoTrabalho} 
                          style={{ width: '40vw' }} 
                          footer={
                            <div>
                              <Button label="Cadastrar" 
                                      className="p-button-primary p-button-text" 
                                      onClick={this.cadastrarGrupoTrabalho}/>
                              &nbsp;
                              <Button label="Fechar" 
                                      className="p-button-secondary p-button-text"
                                      onClick={() => this.fecharModal('modalGrupoTrabalho')}/>
                          </div>
                          }
                          onHide={() => this.fecharModal('modalGrupoTrabalho')}>
                      
                      <div className="p-fluid">
                          <div className="p-field">
                              <label htmlFor="nomeGrupoTrabalho">Nome</label>
                              <InputText id="nomeGrupoTrabalho" 
                                        type="text" 
                                        value={this.state.nomeGrupoTrabalho}
                                        onChange={e => this.setState({nomeGrupoTrabalho: e.target.value})}/>
                          </div>
                          <div className="p-field">
                              <label htmlFor="descricao">Descrição</label>
                              <InputText id="descricao" 
                                        type="text"
                                        value={this.state.descricaoGrupoTrabalho}
                                        onChange={e => this.setState({descricaoGrupoTrabalho: e.target.value})}/>
                          </div>
                      </div>
                  </Dialog>
              </section>
            </div>
        </div>
      </>
    )
  }
}
CadastrarProcesso.contextType = AuthContext;
export default withRouter(CadastrarProcesso)
